import { URL_REG_EXPS } from './url-reg-exps';

export const getProjectFuzeIDsVisibility = (pathname: string): boolean =>
  !URL_REG_EXPS.some((regexp: RegExp) => pathname.match(regexp));
